import Base from './Base'

export default class Category extends Base {
    type = 'category';
    mode = 'simple';

    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'parent', 'position', 'name', 'mode', 'type', 'items', 'extra_ingredients', 'new', 'delete', 'show'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}